import socketio from 'socket.io-client';
const socketIOClient = socketio(process.env.REACT_APP_API_BASE_URL, { transports: ['polling'] })

export default socketIOClient